var React = require('react');

function Heart (props) {
    return React.createElement("svg",props,React.createElement("g",{"className":"heart-loader__group"},[React.createElement("path",{"className":"heart-loader__square","strokeWidth":"1","fill":"none","d":"M0,30 0,90 60,90 60,30z","key":0}),React.createElement("path",{"className":"heart-loader__circle m--left","strokeWidth":"1","fill":"none","d":"M60,60 a30,30 0 0,1 -60,0 a30,30 0 0,1 60,0","key":1}),React.createElement("path",{"className":"heart-loader__circle m--right","strokeWidth":"1","fill":"none","d":"M60,60 a30,30 0 0,1 -60,0 a30,30 0 0,1 60,0","key":2}),React.createElement("path",{"className":"heart-loader__heartPath","strokeWidth":"2","d":"M60,30 a30,30 0 0,1 0,60 L0,90 0,30 a30,30 0 0,1 60,0","key":3})]));
}

Heart.defaultProps = {"className":"heart-loader","viewBox":"0 0 90 90","version":"1.1"};

module.exports = Heart;

Heart.default = Heart;
